import { render } from "./RoomsView.vue?vue&type=template&id=31a44582"
import script from "./RoomsView.vue?vue&type=script&lang=js"
export * from "./RoomsView.vue?vue&type=script&lang=js"

import "./RoomsView.vue?vue&type=style&index=0&id=31a44582&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__